import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert, Spinner, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { backendURL } from './IPaddress';
import './CSS/LoginForm.css';

function ForgotUsernamePage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage(null);
        setIsError(false);
        try {
            const response = await fetch(`${backendURL}/api/forgot-username`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email.trim() }),
                credentials: 'include',
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
                setMessage(data.detail || 'Something went wrong. Please try again.');
                setIsError(true);
                return;
            }
            setMessage(data.message || 'If an account exists with that email, you will receive your username.');
        } catch (err) {
            setMessage('Unable to reach the server. Please try again later.');
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <Container className="auth-page__container">
                <Row className="justify-content-center">
                    <Col xs={11} sm={10} md={5} lg={4}>
                        <Card className="auth-card shadow-sm">
                            <Card.Body>
                                <div className="auth-card__header mb-4">
                                    <h1 className="auth-card__title">Forgot username?</h1>
                                    <p className="auth-card__subtitle mb-0">Enter your email and we’ll send you your username.</p>
                                </div>

                                <Form onSubmit={handleSubmit}>
                                    {message && (
                                        <Alert variant={isError ? 'danger' : 'success'} className="mb-3" onClose={() => setMessage(null)} dismissible>
                                            {message}
                                        </Alert>
                                    )}

                                    <Form.Group controlId="email" className="mb-3">
                                        <Form.Label className="auth-card__label">Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Enter your email"
                                            required
                                            autoComplete="email"
                                            className="auth-card__input py-2"
                                        />
                                    </Form.Group>

                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isLoading}
                                        className="auth-card__submit py-2 mb-3"
                                    >
                                        {isLoading ? (
                                            <>
                                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                {' '}Sending...
                                            </>
                                        ) : (
                                            'Send username'
                                        )}
                                    </Button>

                                    <div className="auth-card__links">
                                        <Link to="/login" className="auth-card__link">Back to login</Link>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ForgotUsernamePage;
